import React, { Fragment, useState, useEffect } from "react"
import { Container, Row, Col } from "react-bootstrap"
import FullCalendar from "components/TriviaCalendarComponents/FullCalendar"
// import SignUpSummary from "components/TriviaCalendarComponents/SignUpSummary/index";
// import UpgradeSummary from "components/TriviaCalendarComponents/upgradeSummary/index";
import { Typography } from "@mui/material"
// import TriviaAnalyticsTable from "components/TriviaCalendarComponents/TriviaAnalyticsTable/TriviaAnalyticsTable"
// import LeaderBoardTable from "components/TriviaCalendarComponents/LeaderBoardTable/LeaderBoardTable"
// import { INITIAL_EVENTS } from "../../../../assets/json/CalendarEvents";
import Header from "components/Header/Header"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import { useDispatch, useSelector } from "react-redux"
import {
  getCalendarDataAction,
  getRestaurantsListAction,
  getTriviaIncorrectAnswersAction
} from "redux/L&D/actions"
import TicketIcon from "assets/icons/TicketIcon.svg"
import CutleryIcon from "assets/icons/CutleryIcon.svg"
import WineGlassIcon from "assets/icons/WineGlassIcon.svg"
import TriviaQuestionIcon from "assets/icons/TriviaQuestionIcon.svg"
import { appActions } from "redux/app/slice/app"
import { formatDate } from "helpers/functions"
import moment from "moment"
import { getLeaderboardDataAction } from "redux/marketing/actions"

// const TriviaColumns = [
//   { id: "Rank", label: "Rank", minWidth: 50 },
//   { id: "Questions", label: "Questions", minWidth: 170 },
//   {
//     id: "Trivia Category",
//     label: "Trivia Category",
//     align: "center",
//     minWidth: 170
//   },
//   {
//     id: "Difficulty Level",
//     label: "Difficulty Level",
//     align: "center",
//     minWidth: 170
//   },
//   {
//     id: "Incorrect Answers",
//     label: "Incorrect Answers",
//     align: "center",
//     minWidth: 170
//   },
//   {
//     id: "Players Answered",
//     label: "Players Answered",
//     align: "center",
//     minWidth: 170
//   },
//   {
//     id: "% Incorrect",
//     label: "% Incorrect",
//     align: "right",
//     minWidth: 170
//   }
// ]

// const TriviaRows = [
//   {
//     id: 1,
//     rank: 1,
//     questions: "What is the retail wine discount for a WCM purchasing 12 or more bottles?",
//     triviaCategory: "Wine Club",
//     difficultyLevel: "Intermediate",
//     inCorrect: "60%"
//   },
//   {
//     id: 2,
//     rank: 2,
//     questions: "Which wine is not a Cooper's Hawk wine?",
//     triviaCategory: "Grape Varietal",
//     difficultyLevel: "Intermediate",
//     inCorrect: "58%"
//   },
//   {
//     id: 3,
//     rank: 3,
//     questions: "Which wine region is not in the United States?",
//     triviaCategory: "Wine Region",
//     difficultyLevel: "Intermediate",
//     inCorrect: "56%"
//   },
//   {
//     id: 4,
//     rank: 4,
//     questions: "What foods pairs best with the Luxe Pinot Noir?",
//     triviaCategory: "Emily’s Wildcard",
//     difficultyLevel: "Intermediate",
//     inCorrect: "55%"
//   },
//   {
//     id: 5,
//     rank: 5,
//     questions: "Which attribute is not a part of January's wine of the month tasting note?",
//     triviaCategory: "Wine Of The Month",
//     difficultyLevel: "Intermediate",
//     inCorrect: "54%"
//   }
// ]

// const LeaderBoardRows = [
//   {
//     id: 1,
//     rank: 1,
//     name: "Scott Hatteberg",
//     image: "https://randomuser.me/api/portraits/men/31.jpg",
//     correctAnswers: "10",
//     signUp_Upgrades: "8",
//     coins: "80"
//   },
//   {
//     id: 2,
//     rank: 2,
//     name: "Carlos Pena",
//     correctAnswers: "8",
//     image: "https://randomuser.me/api/portraits/men/77.jpg",
//     signUp_Upgrades: "5",
//     coins: "40"
//   },
//   {
//     id: 3,
//     rank: 3,
//     name: "Marcella Ellis",
//     correctAnswers: "6",
//     image: "https://randomuser.me/api/portraits/women/40.jpg",
//     signUp_Upgrades: "4",
//     coins: "24"
//   }
// ];

function TriviaCalendar() {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  // const [leaderBoardRowsData, setLeaderBoardRowsData] = useState([])
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(1)
  const { calendarData } = useSelector((store) => store?.learningDevelopment || {})
  // const { data } = useSelector((store) => store?.marketing?.leaderboard || {})
  // const { incorrectAnswers } = useSelector((store) => store?.learningDevelopment?.triviaAnalytics)
  // const filterDate = useSelector((store) => store?.app?.filters?.date);
  const { date, restaurant } = useSelector((state) => state?.app?.filters || "")
  const getIndexFromDate = (date) => parseInt(date?.split("-")?.[2]) - 1

  function getIndexFromDateWine(data) {
    let dateIndex = []
    for (let i = 0; i < data.length; i++) {
      dateIndex.push(parseInt(data[i]?.display_date?.split("-")?.[2]) - 1)
    }
    return dateIndex
  }

  const insertEvents = (formattedData, data) => {
    let date = new Date()
    if (data?.raffle_date) {
      let index = getIndexFromDate(data?.raffle_date)

      if (index >= formattedData.length) {
        for (let i = formattedData.length; i <= index; ++i) {
          date.setDate(i + 1)
          formattedData[i] = { start: formatDate(date), eventData: [] }
        }
      }
      formattedData[index].eventData.push({
        icon: TicketIcon,
        title: `Drawing Raffle for ${moment(formattedData[index].start).format("MMMM")} month`,
        type: "tickets"
      })
    }

    if (data?.wine_club_dinner_data?.length) {
      let dateIndex = getIndexFromDateWine(data?.wine_club_dinner_data)
      for (let i = 0; i <= formattedData.length; i++) {
        formattedData[dateIndex[i]]?.eventData?.push({
          icon: CutleryIcon,
          title: `Wine Club Member Dinner for ${data?.wine_club_dinner_data[i].prize_for_month}`,
          type: "dinner"
        })
        // console.log(formattedData[dateIndex[i]])
      }
    }

    // data.wine_club_dinner = '2022-10-21'

    // if (data?.wine_club_dinner) {
    //   let index = getIndexFromDate(data?.wine_club_dinner);
    //   if (index >= formattedData.length) {
    //     for (let i = formattedData.length; i <= index; ++i) {
    //       date.setDate(i + 1);
    //       formattedData[i] = { start: formatDate(date), eventData: [] };
    //     }
    //   }
    //   formattedData[index].eventData.push({
    //     icon: CutleryIcon,
    //     title: "Wine Club Member Dinner",
    //     type: "dinner"
    //   });
    // }
    // console.log(formattedData)
  }

  const getCalendarDataFormatted = () => {
    let questionCount = 0
    let formattedData =
      calendarData?.map((data) => {
        let newData = {
          start: data?.start_date,
          activePlayers: data?.active_players || "0",
          showStats: true,
          checked: data?.checked || "0",
          eventData: [],
          dailyStats: {},
          incorrectStats: {},
          isIncorrect: data?.incorrect_is_active,
          isCorrect: data?.correct_is_active,
          raffle_date: data?.raffle_date,
          start_day: new Date(data.start_date)?.getDate()
        }
        if (data?.wine_of_the_month) {
          newData.eventData.push({
            icon: WineGlassIcon,
            title: "Featured Item Of The Month",
            type: "wine",
            display: "background",
            backgroundColor: "rgba(164,127,81,0.2)"
          })
        }
        if (data?.stat) {
          let DataNew = {
            total_attempts: data?.stat?.total_attempts,
            total_correct: data?.stat?.total_correct,
            total_incorrect: data?.stat?.total_incorrect,
            percentage_correct: data?.stat?.percentage_correct.toFixed(2) ?? 0,
            percentage_incorrect: data?.stat?.percentage_incorrect.toFixed(2) ?? 0
          }
          DataNew.index = ++questionCount
          newData.dailyStats = DataNew
          if (data.question_published_on) {
            newData.eventData.push({
              icon: TriviaQuestionIcon,
              title: `Trivia Question published`,
              type: "trivia",
              stat: DataNew
            })
          }
          if (data?.note) {
            newData.notes = data?.note
          }
        }
        if (data?.incorrect_trivia_stats) {
          let DataIncorrect = {
            total_attempts: data?.incorrect_trivia_stats?.total_attempts,
            total_correct: data?.incorrect_trivia_stats?.total_correct,
            total_incorrect: data?.incorrect_trivia_stats?.total_incorrect,
            percentage_correct: data?.incorrect_trivia_stats?.percentage_correct.toFixed(2) ?? 0,
            percentage_incorrect: data?.incorrect_trivia_stats?.percentage_incorrect.toFixed(2) ?? 0
          }
          newData.incorrectStats = DataIncorrect
        }
        return newData
      }) || []
    if (formattedData?.length) {
      insertEvents(formattedData, calendarData[0])
    }
    return formattedData
  }

  // function createLeaderBoardListData() {
  //   setLeaderBoardRowsData(
  //     data?.results?.map((res) => ({
  //       id: res.user.id,
  //       rank: res.rank,
  //       name: res.user.name,
  //       image: res.user.image_url,
  //       employeeClass: res.user.job_class ?? "-",
  //       correctAnswers: res.correct_answers ?? "-",
  //       signUp_Upgrades: "-",
  //       coins: res.coins_earned ?? "0",
  //       fairnessFactor: res.fairness_factor ?? "-",
  //       restaurantName: res.user.rest_name ?? "-"
  //     }))
  //   )
  // }

  // useEffect(() => {
  //   createLeaderBoardListData()
  // }, [data])

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Trivia Calendar"
    dispatch(appActions.initFilters())
  }, [])

  useEffect(() => {
    dispatch(getLeaderboardDataAction({ date: date, page: currentPage }))
    dispatch(getTriviaIncorrectAnswersAction({ date, restaurant }))
  }, [date, currentPage, restaurant])

  useEffect(() => {
    if (restaurant) {
      setCurrentPage(1)
    }
  }, [date, restaurant])

  useEffect(() => {
    const dateObject = new Date(date)
    const newDate = new Date(dateObject.getFullYear(), dateObject.getMonth() + 1, 0)
    if (date) {
      getCalendarDataFormatted()
      dispatch(
        getCalendarDataAction({
          date: formatDate(newDate),
          restaurant: restaurant
        })
      )
    }
    dispatch(getRestaurantsListAction())
  }, [date, restaurant])

  return (
    <Fragment>
      <Container fluid className="p-0">
        <Row>
          <Col lg="12">
            <Header
              title={`Trivia Calendar & Leaderboard For ${moment(date).format("MMMM'YY")}`}
              breadCrumbs={breadCrumbs}
            />
          </Col>
        </Row>
        <Row>
          <Col lg="12">
            <Row>
              <Col lg="12" className="mb-4">
                {!calendarData.length ? (
                  <Typography variant="h2" className="mb-4">
                    No Calendar Data Found for this Month
                  </Typography>
                ) : (
                  ""
                )}
                <FullCalendar date={date} events={getCalendarDataFormatted()} />
              </Col>
            </Row>
          </Col>
        </Row>
        {/* <Row>
          <Col lg="12">
            <Row>
              <Col lg="6">
                <SignUpSummary />
              </Col>
              <Col lg="6">
                <UpgradeSummary></UpgradeSummary>
              </Col>
            </Row>
          </Col>
        </Row> */}
      </Container>
      {/* <Container fluid className="p-0 mt-5 ">
        <Typography variant="h2" className="mb-2">
          Leaderboard
        </Typography>
        <Row>
          <Col lg="12">
            <LeaderBoardTable
              setPage={setCurrentPage}
              currentPage={currentPage}
              rowsData={leaderBoardRowsData}
              totalPage={data?.pages}
              columns={LeaderBoardColumns}></LeaderBoardTable>
          </Col>
        </Row>
      </Container>
      <Container fluid className="p-0 mt-5">
        <Typography variant="h2" className="mb-2">
          Most Trivia Questions Answered Incorrectly
        </Typography>
        <Row>
          <Col lg="12">
            <TriviaAnalyticsTable
              rowsData={incorrectAnswers}
              columns={TriviaColumns}
              rows={TriviaRows}></TriviaAnalyticsTable>
          </Col>
        </Row>
      </Container> */}
    </Fragment>
  )
}

export default TriviaCalendar
// const LeaderBoardColumns = [
//   { id: "Rank", label: "Rank", minWidth: 50 },
//   { id: "Name", label: "Name", minWidth: 170 },
//   {
//     id: "Trivia Questions Answered Correctly",
//     label: "Trivia Questions Answered Correctly",
//     align: "center",
//     minWidth: 170
//   },
//   // {
//   //   id: "Signups / Upgrades",
//   //   label: "Signups / Upgrades ",
//   //   align: "center",
//   //   minWidth: 170
//   // },
//   {
//     id: "Coins Earned",
//     label: "Coins Earned",
//     icon: alert,
//     tooltip: "Trivia Questions Answered Correctly * 5 = Coins Earned",
//     align: "center",
//     minWidth: 170
//   }
// ]
